import { CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

export default function PaymentFinish() {
  const { t } = useTranslation();
  return (
    <main className="min-h-screen flex items-center justify-center px-4" data-testid="payment-finish-page">
      <div className="w-full max-w-lg rounded-md border border-border bg-card p-8 text-center">
        <CheckCircle2 className="w-10 h-10 text-verdict-real mx-auto mb-4" />
        <h1 className="font-heading text-2xl font-bold mb-2">
          {t("payment.redirect.finish.title", { defaultValue: "Pembayaran Berhasil" })}
        </h1>
        <p className="text-sm text-muted-foreground">
          {t("payment.redirect.finish.desc", {
            defaultValue: "Transaksi Anda berhasil diproses. Silakan lanjut ke dashboard untuk melihat status paket terbaru.",
          })}
        </p>
        <Link to="/dashboard" className="inline-block mt-6">
          <Button className="rounded-sm bg-brand-primary hover:bg-brand-primary/90 text-white">
            {t("payment.redirect.toDashboard", { defaultValue: "Buka Dashboard" })}
          </Button>
        </Link>
      </div>
    </main>
  );
}

